var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service } from "@bluelibs/core";
import * as Ant from "antd";
import { UsersCollection, } from "@bundles/UIAppBundle/collections";
import { UserRole } from "@root/api.types";
let BankListFiltersForm = class BankListFiltersForm extends XForm {
    build(userRoles) {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "createdAt",
                label: t("management.banks.fields.createdAt"),
                name: ["createdAt"],
                tooltip: t("management.banks.fields.createdAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "updatedAt",
                label: t("management.banks.fields.updatedAt"),
                name: ["updatedAt"],
                tooltip: t("management.banks.fields.updatedAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "name",
                label: t("management.banks.fields.name"),
                name: ["name"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            ...(userRoles.includes(UserRole.ADMIN)
                ? [
                    {
                        id: "createdById",
                        label: t("management.banks.fields.createdBy"),
                        name: ["createdById"],
                        tooltip: t("management.banks.fields.createdBy_description"),
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                    {
                        id: "updatedById",
                        label: t("management.banks.fields.updatedBy"),
                        name: ["updatedById"],
                        tooltip: t("management.banks.fields.updatedBy_description"),
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                ]
                : []),
        ]);
    }
};
BankListFiltersForm = __decorate([
    Service({ transient: true })
], BankListFiltersForm);
export { BankListFiltersForm };
